import React, { PropsWithChildren, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import i18n from '@pages/i18n';
import SEO from '@pages/SEO';

import Video from './components/Video/Video';
import Banner from './components/Banner/Banner';
import Func from './components/Func/Func';
import SubFunc from './components/SubFunc/SubFunc';
import System from './components/System/System';
import Product from './components/Product/Product';
import Contents from './components/Contents/Contents';
import Request from './components/Request/Request';
import NewsLetter from './components/Newletter/NewsLetter';

import constructionSafety from '@src/lang/ko/enterprise/construction/constructionSafety';
import constructionAsset from '@src/lang/ko/enterprise/construction/constructionAsset';
import constructionEquipment from '@src/lang/ko/enterprise/construction/constructionEquipment';
import logisticsAsset from '@src/lang/ko/enterprise/logistics/logisticsAsset';
import logisticsSafety from '@src/lang/ko/enterprise/logistics/logisticsSafety';
import officeAsset from '@src/lang/ko/enterprise/office/officeAsset';
import manufacturingProcess from '@src/lang/ko/enterprise/manufacturing/manufacturingProcess';
import manufacturingAsset from '@src/lang/ko/enterprise/manufacturing/manufacturingAsset';
import medicalPatient from '@src/lang/ko/enterprise/medical/medicalPatient';
import medicalWaste from '@src/lang/ko/enterprise/medical/medicalWaste';
import retailExhibition from '@src/lang/ko/enterprise/retail/retailExhibition';

import seoEnterprise from '@src/lang/ko/seoEnterprise';
import { DivAllCenter, DivFlexRow, DivPadding, FontPage } from '@pages/CommonStyle/commonDiv.style';
import { RefAButton, RefBtnLabel } from './Solution.style';
import { StyledProductBtn, StyledProductBtnA, StyledProductBtnOptions } from '@pages/Main/Common/Product/Product.style';
import { Trans } from 'react-i18next';
import { BorderBottomLine, ImgWH, Spacing, SpacingDTM } from '@pages/CommonStyle/common.style';
import { BlueArrowOut } from '@assets/images/icon/blue';
import ExtraContents from '@pages/Main/Home/components/Solution/Solution';
import RefButtonBar from './components/Ref/RefButtonBar';
import { useSelector } from 'react-redux';
import { CommonState } from '@redux/reducers/commonReducer';
import reatilCart from '@src/lang/ko/enterprise/retail/reatilCart';
import constructionSop from '@src/lang/ko/enterprise/construction/constructionSop';
import constructionManage from '@src/lang/ko/enterprise/logistics/logisticsManage';
import cityDigital from '@src/lang/ko/enterprise/city/cityDigital';
import cityTraffic from '@src/lang/ko/enterprise/city/cityTraffic';
import cityEnergy from '@src/lang/ko/enterprise/city/cityEnergy';
import Lineup from '@pages/Main/Common/Lineup/Lineup';
import { StyledDisplay, StyledParagraph } from '@components/Text';
import { StyledGridContainer } from '@components/Grid/Grid.style';
import digitaltwin from '@src/lang/ko/enterprise/digitaltwin/digitaltwin';

interface ModalDefaultType {
  pageName: string;
}

const Solution = ({ pageName }: PropsWithChildren<ModalDefaultType>) => {
  const paths = {
    constructionSafety: {
      path: constructionSafety,
    },
    constructionAsset: {
      path: constructionAsset,
    },
    constructionEquipment: {
      path: constructionEquipment,
    },
    constructionSop: {
      path: constructionSop,
    },
    constructionManage: {
      path: constructionManage,
    },

    logisticsAsset: {
      path: logisticsAsset,
    },
    logisticsSafety: {
      path: logisticsSafety,
    },

    officeAsset: {
      path: officeAsset,
    },

    manufacturingProcess: {
      path: manufacturingProcess,
    },
    manufacturingAsset: {
      path: manufacturingAsset,
    },

    medicalPatient: {
      path: medicalPatient,
    },
    medicalWaste: {
      path: medicalWaste,
    },

    retailExhibition: {
      path: retailExhibition,
    },

    cityDigital: {
      path: cityDigital,
    },
    cityTraffic: {
      path: cityTraffic,
    },
    cityEnergy: {
      path: cityEnergy,
    },
    digitaltwin: {
      path: digitaltwin,
    },
  };

  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    i18n.changeLanguage('ko').then(() => {
      navigate('', { replace: true });
    });
  }, [location.pathname]);

  const helmetTitle = seoEnterprise.solution[pageName].title;
  const ogKey = seoEnterprise.solution[pageName].key;
  const ogDesc = seoEnterprise.solution[pageName].desc;
  const ogImg = seoEnterprise.solution[pageName].img;
  const ogUrl = seoEnterprise.solution[pageName].url;

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'ORBRO',
    description: `${ogDesc}`,
    alternateName: `${helmetTitle}`,
    url: `${ogUrl}`,
    keywords: `${ogKey}`,
    image: `${ogImg}`,
    serviceType: 'Technical Solution', // 솔루션 유형 정보 추가
    areaServed: 'Global', // 서비스 제공 지역 정보 추가
    provider: {
      '@type': 'Organization',
      name: 'ORBRO',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+82-1522-9928', // 연락처 전화번호 정보 추가
        email: 'pr@orbro.io', // 연락처 이메일 정보 추가
      },
    },
    additionalProperty: {
      '@type': 'PropertyValue',
      name: 'RTLS Technology',
      value: 'Real-Time Location System', // RTLS 기술 설명 추가
    },
    // 기타 추가 정보나 특징 등을 여기에 추가할 수 있습니다.
  };

  const onRequestSection = () => {
    // if (requestRef.current) {
    //   requestRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    // }
  };

  const layoutType = useSelector((state: CommonState) => state.gridLayoutType);
  const [path, setPath] = useState(paths[pageName].path);

  useEffect(() => {
    setPath(paths[pageName].path);
  }, [location.pathname]);

  const currentLang = i18n.language;
  const key = location.pathname;

  // 섹션 refs만 선언하면 끝!
  const videoRef = useRef<HTMLDivElement>(null);
  const funcRef = useRef<HTMLDivElement>(null);
  const productRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  const refs = [videoRef, funcRef, productRef, contentRef];

  return (
    <FontPage key={key}>
      <SEO lang={currentLang} helmetTitle={helmetTitle} ogKey={ogKey} ogDesc={ogDesc} ogImg={ogImg} ogUrl={ogUrl} jsonLd={jsonLd} />

      <Banner pageName={pageName} path={path} onRequestSection={onRequestSection} />

      {layoutType !== 'mobile' && (
        <>
          <SpacingDTM d="64" t="64" m="32" />

          <StyledProductBtnOptions fixed={true} height={52}>
            <RefButtonBar sectionRefs={refs} />
          </StyledProductBtnOptions>
        </>
      )}

      <div ref={videoRef}>
        <Video pageName={pageName} path={path} />
      </div>
      <Spacing pixel="32" />
      <div ref={funcRef}>
        <Func pageName={pageName} path={path} />
      </div>

      {pageName.includes('Waste') && (
        <>
          <StyledGridContainer>
            <DivAllCenter>
              <SpacingDTM d="64" t="64" m="64" />
              <StyledDisplay size="small">
                <Trans i18nKey={`integration.mainPage.product.title`} />
              </StyledDisplay>
              <Spacing pixel="16" />

              <StyledParagraph size="medium">
                <Trans i18nKey={`integration.mainPage.product.desc`} />
              </StyledParagraph>
              <SpacingDTM d="64" t="64" m="64" />
              <Lineup handleIconClickLocal={null} product={'integration'} />
            </DivAllCenter>
            <BorderBottomLine />
          </StyledGridContainer>
        </>
      )}

      <SubFunc pageName={pageName} path={path} />
      {/* <System pageName={pageName} path={path} /> */}
      <div ref={productRef}>
        <Product pageName={pageName} path={path} />
      </div>
      <div ref={contentRef}>
        {/* <Contents pageName={pageName} path={path} /> */}
        <ExtraContents type={'blog'} />
      </div>
      {/* <div ref={requestRef}>
        <Request pageName={pageName} />
      </div> */}

      <SpacingDTM d="64" t="64" m="32" />

      <NewsLetter />
    </FontPage>
  );
};

export default Solution;
